import { Component, inject, signal, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { Sidebar } from '../../ui/sidebar/sidebar';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogService } from '@shared/services/confirmation-dialog.service';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { ChatWidgetComponent } from '@shared/components/chat-widget/chat-widget.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    Sidebar,
    CommonModule,
    ConfirmationDialogComponent,
    ChatWidgetComponent,
  ],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.css',
})
export class MainLayout implements OnInit {
  private readonly router = inject(Router);
  readonly confirmationService = inject(ConfirmationDialogService);

  // Signal to track if we should show the sidebar
  readonly showSidebar = signal(false);

  ngOnInit(): void {
    // Set initial state first
    // Show sidebar for all routes except login
    // Root path '/' will redirect to '/home', so show sidebar for it too
    const shouldShowSidebar = !this.router.url.includes('/login');
    this.showSidebar.set(shouldShowSidebar);

    // Listen to route changes to determine if sidebar should be shown
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Hide sidebar only on login page
        // Root path '/' will redirect to '/home', so show sidebar for it too
        const shouldShow = !event.url.includes('/login');
        this.showSidebar.set(shouldShow);
      });
  }
}
